import { SystemActionLogsTypeEnum, useGetSystemActionCountQuery } from "gql/generated.graphql";
import DashboardWidgetContainer from "../DashboardWidgetContainer/DashboardWidgetContainer";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { useCallback, useContext, useMemo } from "react";
import { DatePeriodTypesEnum, FilterContext, getPeriodRangeByPeriodType } from "dash-ui";


const DashboardWidgetPropertyShare = () => {
  const theme = useTheme();
  const { t } = useTranslation('pages');
  const { state: filterState } = useContext(FilterContext);
  const propertyId = filterState?.propertyId;

  const { data: dataPeriod, loading: loadingPeriod } =
    useGetSystemActionCountQuery({
      variables: {
        filter: {
          propertyId: filterState?.propertyId,
          type: SystemActionLogsTypeEnum.PropertyShared,
          dateRange: filterState.dateRange
          ? {
              startDate: filterState.dateRange?.startDate,
              endDate: filterState.dateRange?.endDate,
            }
          : getPeriodRangeByPeriodType(DatePeriodTypesEnum.CURRENT_WEEK),
        },
      },
      skip: propertyId === '' || propertyId === undefined,
    });

  const { countPeriod } = useMemo(
    () => ({
      countPeriod: dataPeriod?.getSystemActionCount || 0,
    }),
    [dataPeriod]
  );

  const { data, loading } =
  useGetSystemActionCountQuery({
      variables: {
        filter: {
          propertyId: filterState?.propertyId,
          type: SystemActionLogsTypeEnum.PropertyShared,
        },
      },
      skip: propertyId === '' || propertyId === undefined,
    });

  const { count } = useMemo(
    () => ({
      count: data?.getSystemActionCount || 0,
    }),
    [data]
  );

  const makePlaceholderText = useCallback(() => {
    if (count === 0) {
      return t('organizationDashboardPage.propertySharesPlaceholderText') || '';
    }
    return t('organizationDashboardPage.propertySharesPlaceholderTextPeriod') || '';
  }, [count, t])

  return (
    <DashboardWidgetContainer
      bgColor={theme.colors.p10}
      icon="screenShare"
      placeholderTitle={
        t('organizationDashboardPage.propertySharesPlaceholderTitle') || ''
      }
      placeholderText={makePlaceholderText()}
      count={countPeriod}
      loading={loadingPeriod && loading}
    />
  )
}

export default DashboardWidgetPropertyShare;
